import { render } from "./nullPointerExceptionComponent.vue?vue&type=template&id=664607fc&scoped=true"
import script from "./nullPointerExceptionComponent.vue?vue&type=script&lang=js"
export * from "./nullPointerExceptionComponent.vue?vue&type=script&lang=js"

import "./nullPointerExceptionComponent.vue?vue&type=style&index=0&id=664607fc&scoped=true&lang=css"

import exportComponent from "C:\\Users\\Anupashyam\\Downloads\\gitlabs - rel path oops\\virtuallab-oop\\exp-10\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-664607fc"]])

export default __exports__